import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/",
    component: () =>
      import(/* webpackChunkName: "baseLayout" */ "@/layouts/BaseLayout.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "/",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/menu/HomeView.vue"),
        meta: {
          requiresAuth: false,
          title: "Tarjeta Tu Puente - Home"
        }
      },
      {
        path: "/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/auth/LoginView.vue"),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Login"
        }
      },
      {
        path: "/signup",
        name: "signup",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/auth/RegisterView.vue"
          ),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Registro"
        }
      },
      {
        path: "/recuperar",
        name: "recuperar",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/auth/RecoverPassView.vue"
          ),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Recuperar"
        }
      },
      {
        path: "/reenviar",
        name: "reenviar",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/auth/ValidateAccountView.vue"
          ),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Reenviar"
        }
      },
      {
        path: "/destacados",
        name: "Destacados",
        component: () =>
          import(
            /* webpackChunkName: "destacados" */ "@/views/Beneficios/DestacadosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Beneficios Destacados"
        }
      },
      {
        path: "/beneficios",
        name: "Beneficios",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Beneficios/HomeBeneficiosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Beneficios"
        }
      },
      {
        path: "/categorias",
        name: "Categorias",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Beneficios/CategoriasView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Categorias"
        }
      },
      {
        path: "/convenios/:nombre",
        name: "Comercios",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Beneficios/ConveniosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Comercios"
        }
      },

      {
        path: "/beneficio/:nombre",
        name: "Beneficio",
        component: () =>
          import(
            /* webpackChunkName: "beneficio" */ "@/views/Beneficios/BeneficioView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Beneficio"
        }
      },

      {
        path: "/hazte-socio",
        name: "HazteSocio",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Socios/HazteSocioView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Hazte Socio"
        }
      },

      {
        path: "/preguntas-frecuentes",
        name: "Preguntas",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Preguntas/PreguntasFrecuentesView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Preguntas Frecuentes"
        }
      },

      {
        path: "/contacto",
        name: "Contacto",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Contacto/ContactoView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Contacto"
        }
      },

      {
        path: "/terminos",
        name: "Terminos",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Terminos/TerminosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Términos y Condiciones"
        }
      },

      {
        path: "/socios",
        name: "Socios",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Socios/SociosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Registrar como Socio"
        }
      },
      {
        path: "/vecinos",
        name: "ApplicationsList",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/Dashboard/ApplicationsListView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Solicitudes"
        }
      },
      {
        path: "/validar",
        name: "Applications",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/components/Dashboard/Applications.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Validar"
        }
      },
      {
        path: "/solicitud/editar",
        name: "ApplicationEdit",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/components/Dashboard/Applications.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Editar"
        }
      },
      {
        path: "detalles/:id",
        name: "ApplicationDetails",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/components/Dashboard/ApplicationDetail.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Detalles"
        }
      },
      {
        path: "/solicitud",
        name: "solicitud",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/Dashboard/NewApplicationView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Solicitud"
        }
      },
      {
        path: "/perfil",
        name: "perfil",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/menu/MisDatosView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Perfil"
        }
      },
      {
        path: "/editar",
        name: "editar",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/menu/editarPerfilView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Editar"
        }
      },
      {
        path: "/configuracion",
        name: "configuracion",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/menu/ConfiguracionView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Configuración"
        }
      },
      {
        path: "/descargar",
        name: "Descarga",
        component: () =>
          import(
            /* webpackChunkName: "Descarga" */ "@/views/Descarga/DescargaView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Tu Puente"
        }
      },
      {
        path: "/noticias",
        name: "Noticias",
        component: () =>
          import(
            /* webpackChunkName: "Noticias" */ "@/views/Noticias/NoticiasView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Noticias - Tu Puente"
        }
      },
      {
        path: "/noticias/:nombre",
        name: "PublicacionNoticia",
        component: () =>
          import(
            /* webpackChunkName: "Noticias" */ "@/views/Noticias/PublicacionNoticiaView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Noticia - Tu Puente"
        }
      },
      {
        path: "/actividades",
        name: "Actividades",
        component: () =>
          import(
            /* webpackChunkName: "Actividades" */ "@/views/Actividades/ActividadesView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Actividades - Tu Puente"
        }
      },
      {
        path: "/actividades/:nombre",
        name: "PublicacionAct",
        component: () =>
          import(
            /* webpackChunkName: "Publicacion" */ "@/views/Actividades/PublicacionView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Actividad - Tu Puente"
        }
      },
      {
        path: "/cuenta/eliminar",
        name: "EliminarCuenta",
        component: () =>
          import(
            /* webpackChunkName: "encuesta" */ "@/views/Web/EliminarCuentaView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/auth",
        name: "RecoverFirebase",
        component: () =>
          import(
            /* webpackChunkName: "RecoverFirebase" */ "@/views/auth/RecoverFirebaseView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const authenticated = Store.state.authenticated;

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  const notLogged = to.matched.some(record => record.meta.notLogged);

  if (requiresAuth && !authenticated) {
    next("/login");
  } else if (!requiresAuth && authenticated) {
    if (notLogged) {
      next("/vecinos");
    } else {
      next();
    }
  } else {
    next();
  }
});
const DEFAULT_TITLE = "Tarjeta Puente Alto";
router.afterEach((to: any, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});
export default router;
